import { supabase } from '../lib/supabase';
import emailService from './emailService';

/**
 * Transaction Service for managing cryptocurrency transactions
 */
class TransactionService {
  /**
   * Create a new transaction
   */
  async createTransaction(userId, transactionData) {
    try {
      const { data, error } = await supabase?.from('transactions')?.insert({
          user_id: userId,
          type: transactionData?.type,
          status: transactionData?.status || 'completed',
          crypto_symbol: transactionData?.cryptoSymbol,
          crypto_amount: transactionData?.cryptoAmount,
          usd_amount: transactionData?.usdAmount,
          price_per_unit: transactionData?.pricePerUnit,
          description: transactionData?.description,
          fee_amount: transactionData?.feeAmount || 0,
          notes: transactionData?.notes,
          completed_at: transactionData?.status === 'completed' ? new Date()?.toISOString() : null
        })?.select()?.single();

      if (error) throw error;

      // Send transaction confirmation email
      if (data) {
        emailService?.sendTransactionConfirmation(userId, {
          type: data?.type,
          description: data?.description,
          cryptoSymbol: data?.crypto_symbol,
          cryptoAmount: data?.crypto_amount,
          usdAmount: data?.usd_amount,
          feeAmount: data?.fee_amount,
          status: data?.status
        });
      }

      return { data, error: null };
    } catch (error) {
      console.error('Failed to create transaction:', error);
      return { data: null, error: error?.message };
    }
  }

  /**
   * Get user transactions
   */
  async getUserTransactions(userId, limit = 10) {
    try {
      const { data, error } = await supabase?.from('transactions')?.select('*')?.eq('user_id', userId)?.order('created_at', { ascending: false })?.limit(limit);

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Failed to fetch transactions:', error);
      return { data: null, error: error?.message };
    }
  }

  /**
   * Get transaction by ID
   */
  async getTransactionById(transactionId) {
    try {
      const { data, error } = await supabase?.from('transactions')?.select('*')?.eq('id', transactionId)?.single();

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Failed to fetch transaction:', error);
      return { data: null, error: error?.message };
    }
  }

  /**
   * Update transaction status
   */
  async updateTransactionStatus(transactionId, status) {
    try {
      const { data, error } = await supabase?.from('transactions')?.update({ 
          status: status,
          completed_at: status === 'completed' ? new Date()?.toISOString() : null
        })?.eq('id', transactionId)?.select()?.single();

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Failed to update transaction:', error);
      return { data: null, error: error?.message };
    }
  }
}

export default new TransactionService();